import React from 'react';
import PropTypes from 'prop-types';

// Style
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
    minWidth: 1000,
  },
  content: {
    padding: `${theme.spacing(4)}px ${theme.spacing(6)}px`,
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    overflowY: 'auto',
  },
  container: {
    maxWidth: 1400,
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
  },
});

export const PageContext = React.createContext();

/**
 * Page
 */
class Page extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object.isRequired,
  };

  componentDidMount() {
    // This is needed because on first render, 'this.pageToolbar' ref is undefined.
    this.setState({ mounted: true });
  }

  render() {
    const { children: childrenProp, classes } = this.props;
    const children = React.Children.toArray(childrenProp);

    return (
      <PageContext.Provider value={this.pageToolbar}>
        <div className={classes.root}>
          <div className={classes.content}>
            <div className={classes.container}>{children}</div>
          </div>
          <div ref={c => (this.pageToolbar = c)} />
        </div>
      </PageContext.Provider>
    );
  }
}

export default withStyles(styles)(Page);
